import React, { useEffect } from 'react';
import { useConfirmStore } from '../store/confirmStore';

export const ConfirmationDialog: React.FC = () => {
  const { isOpen, options, onConfirm, onCancel } = useConfirmStore();

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onCancel();
      } else if (e.key === 'Enter') {
        onConfirm();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onConfirm, onCancel]);

  if (!isOpen || !options) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 backdrop-blur-md bg-slate-950/60 animate-fade-in">
      <div 
        className="w-full max-w-md overflow-hidden rounded-2xl border border-slate-800/80 bg-slate-900/90 p-6 text-left align-middle shadow-2xl transition-all scale-up-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header / Title */}
        <h3 className="text-lg font-semibold leading-6 text-white flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-indigo-500 animate-pulse" />
          {options.title || 'Подтверждение действия'}
        </h3>
        
        {/* Message */}
        <div className="mt-3">
          <p className="text-sm text-slate-300 whitespace-pre-wrap leading-relaxed">
            {options.message}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-slate-300 hover:text-white rounded-lg border border-slate-700 hover:bg-slate-800/80 transition-all duration-200"
            onClick={onCancel}
          >
            {options.cancelText || 'Отмена'}
          </button>
          
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-white rounded-lg bg-indigo-600 hover:bg-indigo-500 hover:shadow-lg hover:shadow-indigo-600/20 active:bg-indigo-700 transition-all duration-200"
            onClick={onConfirm}
          >
            {options.confirmText || 'Продолжить'}
          </button>
        </div>
      </div>
    </div>
  );
};
